import { toDisplayLong, isEventOrganizer } from '../helpers';
import EventCard from '../ui/EventCard';
import CreateEventButton from '../ui/CreateEventButton';

function NextEvent({ events, venues, currentUser, onSelectEvent, onCreateEvent, venueEquipment, onGoToSerate, defaultVenueBg }) {
  const today = new Date(); today.setHours(0,0,0,0);

  const myEvents = events.filter(ev => {
    const isOrganizer = isEventOrganizer(ev, currentUser.id);
    const isParticipant = (ev.event_participants||[]).some(p => p.musician_id === currentUser.id);
    const evDate = new Date(ev.date); evDate.setHours(0,0,0,0);
    return (isOrganizer || isParticipant) && evDate >= today;
  }).sort((a,b) => new Date(a.date) - new Date(b.date));

  const nextEvent = myEvents[0] || null;
  const otherEvents = myEvents.slice(1);

  // Empty state
  if (!nextEvent) return (
    <div className="fade-up">
      <div style={{marginBottom:24,textAlign:"center"}}>
        <div style={{fontSize:26,fontWeight:800,color:"var(--text)",lineHeight:1.1}}>Prossima Jam</div>
        <div style={{fontSize:16,color:"var(--muted)",marginTop:6}}>Scegliamo cosa suonare e cosa ci serve</div>
      </div>
      <div style={{background:"rgba(237,77,29,0.04)",border:"1px dashed rgba(237,77,29,0.2)",borderRadius:16,padding:"28px 20px",textAlign:"center",marginBottom:16}}>
        <div style={{fontSize:17,fontWeight:800,color:"var(--text)",marginBottom:8,lineHeight:1.5}}>
          Non ti sei ancora registrato ad una serata.
        </div>
        <div style={{fontSize:16,color:"var(--muted)",lineHeight:1.7,marginBottom:20}}>
          Hai ricevuto un invito? Apri il link che ti è stato mandato. Oppure trova una serata vicino a te.
        </div>
        <button className="btn btn-teal" style={{width:"100%",justifyContent:"center",marginBottom:8}}
          onClick={()=>onGoToSerate&&onGoToSerate()}>Cerca serate vicino a te</button>
        <CreateEventButton currentUser={currentUser} venues={venues} venueEquipment={venueEquipment}
          onCreateEvent={onCreateEvent} className="btn btn-secondary"/>
      </div>
    </div>
  );

  return (
    <div className="fade-up">
      <div style={{marginBottom:24,textAlign:"center"}}>
        <div style={{fontSize:26,fontWeight:800,color:"var(--text)",lineHeight:1.1}}>Prossima Jam</div>
        <div style={{fontSize:16,color:"var(--muted)",marginTop:6}}>Scegliamo cosa suonare e cosa ci serve</div>
      </div>

      {/* Prossimo evento — grande */}
      {nextEvent && (
        <EventCard ev={nextEvent} venues={venues} currentUser={currentUser} onSelect={onSelectEvent} defaultVenueBg={defaultVenueBg}/>
      )}

      {/* Altri tuoi eventi futuri — lista compatta */}
      {otherEvents.length > 0 && <>
        <div style={{fontSize:16,color:"var(--muted)",textTransform:"uppercase",letterSpacing:".8px",fontWeight:700,margin:"18px 0 10px"}}>Anche in programma</div>
        {otherEvents.map(ev => {
          const venue = venues.find(v => v.id === ev.venue_id);
          const partCount = (ev.event_participants||[]).length;
          return (
            <div key={ev.id} onClick={()=>onSelectEvent(ev)}
              style={{background:"var(--surface)",border:"1px solid rgba(237,77,29,0.08)",borderLeft:"3px solid #ED4D1D",borderRadius:12,padding:"10px 13px",display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8,cursor:"pointer"}}>
              <div>
                <div style={{fontSize:16,fontWeight:700,color:"var(--text)"}}>{ev.title}</div>
                <div style={{fontSize:16,color:"var(--muted)"}}>{toDisplayLong(ev.date)}{venue?` · ${venue.name}`:""}{partCount>0?` · ${partCount} musicisti`:""}</div>
              </div>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--muted)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0,marginLeft:8}}>
                <polyline points="9 18 15 12 9 6"/>
              </svg>
            </div>
          );
        })}
      </>}

      {/* Azioni in fondo */}
      <div style={{marginTop:20,display:"flex",flexDirection:"column",gap:8}}>
        <button className="btn btn-secondary" style={{width:"100%",justifyContent:"center"}}
          onClick={()=>onGoToSerate&&onGoToSerate()}>Tutte le serate</button>
        <CreateEventButton currentUser={currentUser} venues={venues} venueEquipment={venueEquipment}
          onCreateEvent={onCreateEvent}/>
      </div>
    </div>
  );
}

export default NextEvent;
